(ns io.daskul.webapp.widgets.dashboard.alert-card
  "Alert card widget — renders an actionable warning/info alert.

   Expects a metric map with :widget :alert shape:
     {:widget   :alert
      :key      \"overdue-invoices\"
      :severity :warning           ;; :info | :warning | :critical
      :label    \"Overdue Invoices\"
      :count    5
      :message  \"5 invoices overdue >15 days\"
      :action   {:type :navigate :href \"/invoices?state=overdue\"}}"
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.ui.icons :as icons]))

(defn- severity-color [severity]
  (case severity
    :critical "red"
    :warning  "yellow"
    :info     "blue"
    "gray"))

(defn- severity-icon [severity]
  (case severity
    :critical icons/icon-alert-circle
    :warning  icons/icon-alert-triangle
    :info     icons/icon-info-circle
    icons/icon-info-circle))

(defui alert-card
  "Renders an alert metric as a colored alert box with optional action link."
  [{:keys [severity label message count action]}]
  (let [severity (keyword severity)
        color    (severity-color severity)
        icon     (severity-icon severity)]
    ($ ui/alert {:variant "light"
                 :color   color
                 :title   (if count (str label " (" count ")") label)
                 :icon    ($ icon)}
      ($ ui/text {:size "sm"} message)
      (when-let [href (:href action)]
        ($ ui/anchor {:href href :size "sm" :fw 500 :mt "xs"}
          "View details")))))
